import { ContainerTI, Card, Quantity, Graphic } from './styles';
import { Props } from './types';
import { InfoCircleOutlined, LoadingOutlined } from '@ant-design/icons';
import { Tooltip, Select } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../../../../store';
import BasicLineSetStyle from '../../../../graphics/BasicLineSetStyle';
import { loadRequest } from '../../../../../../store/ducks/kpiAC/actions';
import moment from 'moment';
import React from 'react';
import DetalhesOcorrencia from '../../modalDetalhesOcorrencia';

const CardAC: React.FC<Props> = ({ cdd, inscricao }) => {
  const dispatch = useDispatch();
  const { Option } = Select;
  const loading = useSelector((state: ApplicationState) => state?.KPIAC?.loading);
  const data = useSelector((state: ApplicationState) => state?.KPIAC?.data[0]);
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [date, setDate] = React.useState(7);

  React.useEffect(() => {
    dispatch(loadRequest(cdd, inscricao, moment().subtract(7, 'days').format(), 'AC', 1));
    localStorage.setItem('filterkpiAC', moment().subtract(7, 'days').format());
  }, [cdd, dispatch, inscricao]);

  const handleDate = (value: number) => {
    setDate(value);
    dispatch(loadRequest(cdd, inscricao, moment().subtract(value, 'days').format(), 'AC', 1));
    localStorage.setItem('filterkpiAC', moment().subtract(value, 'days').format());
  };

  return (
    <Card key={data?.card} className="themeSLA">
      <DetalhesOcorrencia
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        protocolos={data?.protocolos}
      />
      <ContainerTI className="containerTI">
        <div className="ti">
          <h2 className="title">{data?.card}</h2>
          <span className="info">
            <Tooltip title={`Todos os atendimentos finalizados no período de ${date} dias`}>
              <InfoCircleOutlined role="tooltip" style={{ cursor: 'pointer' }} />
            </Tooltip>
          </span>
        </div>
        <Quantity onClick={() => setIsModalOpen(true)}>
          {!loading ? data?.total?.toString()?.padStart(2, '0') : <LoadingOutlined />}
        </Quantity>
      </ContainerTI>

      <Graphic>
        <BasicLineSetStyle data={data?.data} />
      </Graphic>

      <Select
        defaultValue={7}
        bordered={false}
        style={{ width: '100%', marginTop: '20px 0', fontWeight: 'bold', background: '#F1F1F1' }}
        onChange={handleDate}
      >
        <Option value={7}>Últimos 7 dias</Option>
        <Option value={15}>Últimos 15 dias</Option>
        <Option value={30}>Últimos 30 dias</Option>
      </Select>
    </Card>
  );
};

export default CardAC;
